import { BASE_URL_API } from "constants/base-url-api";
import { getCookie } from "utils/functions-cookie";

export const changeUserEmail = async (rest: string, token: string) => {
  const authToken = getCookie("auth_token");
  const data = { 
    email: token,
    token
  }

  const response = await fetch(`${BASE_URL_API}/users/${rest}/email`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify(data),
  });

  return response.status
};

export const verifyUserEmail = async (new_user_email: string, user_id: string) => {
  const authToken = getCookie("auth_token");
  const data = { new_user_email }

  const response = await fetch(`${BASE_URL_API}/users/${user_id}/verify_email`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify(data),
  });

  return response.status
};